var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymptomItchyVagina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H109C114.523 0 119 4.47715 119 10V114H0V10Z",
    fill: "#FFBB96",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 92C76.6731 92 91 77.6731 91 60C91 42.3269 76.6731 28 59 28C41.3269 28 27 42.3269 27 60C27 77.6731 41.3269 92 59 92Z",
    fill: "#FFD9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 60C91 77.6725 76.6725 92 59 92V28C76.6725 28 91 42.3275 91 60Z",
    fill: "#FFBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0002 49.4563L47.0002 49.4313C46.9152 45.28 49.1252 41.5038 52.1714 38.8288C53.9827 37.0175 55.0002 34.5613 55.0002 32C54.9899 29.8675 56.7523 28.0192 59.0002 28C61.1327 27.9898 62.981 29.7522 63.0002 32C62.9949 34.4262 63.9899 37.0095 65.8289 38.8288C69.1277 41.7663 71.0139 45.31 71.0002 49.4563Z",
    fill: "#FF6352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 49.4563L59 49.4438V28C61.1325 27.9898 62.9809 29.7522 63 32C62.9947 34.4262 63.9897 37.0095 65.8287 38.8288C69.1275 41.7663 71.0137 45.31 71 49.4563Z",
    fill: "#F52C4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5326 64.0288C78.5326 71.06 74.4426 73.9375 73.0601 78.085C69.5476 88.62 59.0126 91.905 59.0126 91.905H58.9863C58.9863 91.905 48.4513 88.62 44.9388 78.085C43.5563 73.9375 39.4663 71.06 39.4663 64.0288C39.4663 60.525 43.3113 59.2075 42.8151 56.7825C41.4276 49.9888 44.9688 50.0713 50.8938 48.3688C53.2051 46.3675 56.0988 44 58.9901 44H58.9988H59.0001C61.8938 43.995 64.7926 46.365 67.1051 48.3688C73.0301 50.0713 76.5726 49.9888 75.1838 56.7825C74.6876 59.2075 78.5326 60.525 78.5326 64.0288Z",
    fill: "#FFBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5325 64.0288C78.5325 71.06 74.4425 73.9375 73.06 78.085C69.5475 88.62 59.0125 91.905 59.0125 91.905H59V44C61.8937 43.995 64.7925 46.365 67.105 48.3688C73.03 50.0713 76.5725 49.9888 75.1838 56.7825C74.6875 59.2075 78.5325 60.525 78.5325 64.0288Z",
    fill: "#F0A278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2264 70.7137C67.2264 79.0912 59.0002 85.8824 59.0002 85.8824C59.0002 85.8824 50.7739 79.0912 50.7739 70.7137C50.7739 62.3362 59.0002 55.5449 59.0002 55.5449C59.0002 55.5449 67.2264 62.3362 67.2264 70.7137Z",
    fill: "#F52C4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2262 70.7137C67.2262 79.0912 59 85.8824 59 85.8824V55.5449C59 55.5449 67.2262 62.3362 67.2262 70.7137Z",
    fill: "#BF0358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4923 77.5989C63.4923 82.1739 58.9998 85.8827 58.9998 85.8827C58.9998 85.8827 54.5073 82.1739 54.5073 77.5989C54.5073 73.0252 58.9998 69.3164 58.9998 69.3164C58.9998 69.3164 63.4923 73.0252 63.4923 77.5989Z",
    fill: "#BF0358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4925 77.5989C63.4925 82.1739 59 85.8827 59 85.8827V69.3164C59 69.3164 63.4925 73.0252 63.4925 77.5989Z",
    fill: "#8F0246"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(27 28)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomItchyVagina);
export default __webpack_public_path__ + "static/media/symptom-Itchy-Vagina.b72137ba31ebe95e4a0191057a727227.svg";
export { ForwardRef as ReactComponent };